import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Grid, Col, Row } from 'react-bootstrap'
import { useTrackingTrigger } from '@indeed/flex-tracking-context'

import entityDetail from 'syft-acp-util/entityDetail'
import SetFilter from 'syft-acp-core/components/SetFilter'
import SiteComponent from 'syft-acp-core/components/SiteComponent'
import RecordSection from 'syft-acp-core/components/RecordSection'
import EntityAlert from 'syft-acp-core/components/Alerts/EntityAlert'
import * as conductReviewsActions from 'syft-acp-core/store/conductReviews/actions'

import BanReviewDetailsControls from './BanReviewDetailControls'
import { BanReviewDetailProps as Props } from './BanReviewDetail.types'
import { getDataStructure } from './BanReviewDetail.constants'
import { trackingEvents } from './BanReviewDetail.tracking'

export const storeConnector = connect(
  (state: any) => ({
    countryCode: state.auth?.userData?.country_code,
  }),
  dispatch => ({
    actions: bindActionCreators({ ...conductReviewsActions }, dispatch),
  }),
)

export const BanReviewDetail = ({
  actions,
  actionUpdate,
  data,
  id,
  lastBody,
  isPristine,
  countryCode,
}: Props) => {
  const triggerEvent = useTrackingTrigger()
  const isClosed = isPristine && !!data.outcome

  useEffect(() => {
    actions.fetchConductReview(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    triggerEvent(trackingEvents.PAGE.VIEWED, { conduct_review_id: id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const country = countryCode === 'GB' ? 'UK' : 'US'

  return (
    <>
      <SetFilter queryKey="exclude_never_activated" />
      <SetFilter queryKey="paginated" />
      <SiteComponent>
        <Grid>
          <Row>
            <Col md={12} sm={12}>
              <BanReviewDetailsControls id={id} data={data} isPristine={isPristine} />
              <EntityAlert lastBody={lastBody} />
              {getDataStructure(isClosed, country).map(({ title, structure }) => (
                <RecordSection
                  key={title}
                  title={title}
                  data={data}
                  structure={structure}
                  update={actionUpdate}
                />
              ))}
            </Col>
          </Row>
        </Grid>
      </SiteComponent>
    </>
  )
}

export default storeConnector(entityDetail('conductReviews', BanReviewDetail))
